import { render, staticRenderFns } from "./ChooseMater.vue?vue&type=template&id=5f711f27&scoped=true"
import script from "./ChooseMater.vue?vue&type=script&lang=js"
export * from "./ChooseMater.vue?vue&type=script&lang=js"
import style0 from "./ChooseMater.vue?vue&type=style&index=0&id=5f711f27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f711f27",
  null
  
)

export default component.exports